export var RSCheckoutLocation = {
    Cart: 'cart',
    CartTray: 'cart-tray',
    Checkout: 'checkout', // required to conditionally not fire on checkout page
};
export var RSCheckoutStep = {
    Shipping: 'shipping',
    Payment: 'payment',
};
export var RSPageType = {
    About: 'about',
    AboutSelling: 'about-selling',
    Agreement: 'agreement',
    ArtistExplore: 'artist-explore',
    ArtistShop: 'artist-shop',
    Cart: 'cart',
    Checkout: 'check-out',
    CookiePolicy: 'cookie-policy',
    GiftCard: 'gift-card',
    Home: 'home',
    Privacy: 'privacy',
    Product: 'pdp',
    Search: 'srp',
    SizeguideModal: 'sizeguide-modal',
};
export var RSProductClickedLocation = {
    AlsoAvailableOnModal: 'also_available_on_modal',
    OffsiteSimilarDesigns: 'offsite_similar_designs_carousel',
    AlsoAvailableOnCarousel: 'also_available_on_carousel',
    SimilarDesignsCarousel: 'similar_designs_carousel',
    SimilarDesignsATCDrawer: 'similar_designs_atc_drawer',
    ArtistAttributionCarousel: 'more_by_this_artist',
    SearchResultsPageResults: 'srp_results',
    ArtistShopPageResults: 'artist_shop_results',
    LicensedProductsCarousel: 'licensed_products_carousel',
    ProductFeed: 'product_feed',
    FanArtCarousel: 'fan_art_carousel',
    SimilarProductsCarousel: 'similar_products_carousel',
    SuggestedProductsCarousel: 'suggested_products_carousel',
};
